var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable max-statements */
import Loading from '@web/components/layout/Loading';
import MembersFilters from '@web/components/Settings/Members/MembersFilters';
import OrgUnitsSection from '@web/components/Settings/Members/OrgUnitsSection';
import UsersSection from '@web/components/Settings/Members/UsersSection';
import { trpc } from '@web/lib/trpc';
import { googleAdminManageOrgUnitsUrl, googleAdminMoveUsersToOrgUnitUrl } from '@web/router/urls';
import { getOrgUnitNameWithParent } from '@web/utility';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
var Members = function () {
    var _a = trpc.allUsers.useQuery({
        isActive: null,
        isInGoogle: true
    }), allUsers = _a.data, refetchUsers = _a.refetch;
    var _b = trpc.allOrgUnits.useQuery(), allOrgUnits = _b.data, refetchOrgUnits = _b.refetch;
    var _c = useState(''), usersQuery = _c[0], setUsersQuery = _c[1];
    var _d = useState(''), orgUnitsQuery = _d[0], setOrgUnitsQuery = _d[1];
    var _e = useState(null), selectedOrgUnitId = _e[0], setSelectedOrgUnitId = _e[1];
    if (!allUsers || !allOrgUnits)
        return _jsx(Loading, {});
    var filteredUsers = allUsers
        .filter(function (user) {
        if (usersQuery) {
            var searchString = user.name || user.email;
            return searchString.toLowerCase().includes(usersQuery.toLowerCase());
        }
        if (selectedOrgUnitId) {
            return user.userOrgUnits.some(function (orgUnit) { return orgUnit.orgUnit.id === selectedOrgUnitId; });
        }
        return true;
    })
        .map(function (user) {
        var orgUnit = user.userOrgUnits.find(function (orgUnit) { return orgUnit.isInGoogle; });
        return __assign(__assign({}, user), { orgUnitName: orgUnit === null || orgUnit === void 0 ? void 0 : orgUnit.orgUnit.title, orgUnitNameWithParent: getOrgUnitNameWithParent(orgUnit === null || orgUnit === void 0 ? void 0 : orgUnit.orgUnit) });
    });
    return (_jsxs(_Fragment, { children: [_jsx(MembersFilters, { usersQuery: usersQuery, setUsersQuery: setUsersQuery, orgUnitsQuery: orgUnitsQuery, setOrgUnitsQuery: setOrgUnitsQuery, activeUsers: allUsers.filter(function (user) { return user.isActive; }) }), _jsxs("div", __assign({ className: "grid grid-cols-4" }, { children: [_jsx("div", __assign({ className: "pr-4 md:col-span-1 lg:col-span-1 col-span-4 col-start-1" }, { children: _jsxs("div", __assign({ className: "mb-10" }, { children: [_jsx(OrgUnitsSection, { orgUnits: allOrgUnits, orgUnitsQuery: orgUnitsQuery, selectedOrgUnitId: selectedOrgUnitId, setSelectedOrgUnitId: setSelectedOrgUnitId, refetchOrgUnits: refetchOrgUnits, refetchUsers: refetchUsers }), _jsx("div", __assign({ className: "mt-4 rounded-md border border-sky-200 bg-sky-50 px-4 py-3 text-xs text-sky-800" }, { children: _jsx(Trans, { i18nKey: "settingsMembers.orgUnitsNotice", components: {
                                            linkManageOrgUnits: (_jsx(Link, { to: googleAdminManageOrgUnitsUrl, target: "_blank", rel: "noreferrer", className: "underline" })),
                                            linkGroupEmployees: (_jsx(Link, { to: googleAdminMoveUsersToOrgUnitUrl, target: "_blank", rel: "noreferrer", className: "underline" }))
                                        } }) }))] })) })), _jsx("div", __assign({ className: "md:col-span-3 lg:col-span-3 col-span-4 col-start-1" }, { children: _jsx(UsersSection, { allOrgUnits: allOrgUnits, users: filteredUsers, refetch: refetchUsers }) }))] }))] }));
};
export default Members;
